import { useAuth, useMarketplace } from "hooks";

export const useTimeZone = (): string => {
	const auth = useAuth();
  const marketplace = useMarketplace();

  return marketplace?.schedule.timeZone || auth.timeZone!;
};

export default useTimeZone;